



































import { Component, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { CollectionList } from '@/api'
import { CollectionListStatus, SortOrder } from '@/types'
import { orderBy } from 'lodash'
import {
  DataTable,
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import dayjs from 'dayjs'
import { collectionListStore } from '@/utils/store-accessor'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    items: [
      {
        name: 'name',
        headerText: '名称',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '25',
    resizable: true,
    items: [
      {
        name: 'nameKana',
        headerText: '名称（カナ）',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'registrationCount',
        headerText: '登録件数',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'releaseDate',
        headerText: '公開期間',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'priority',
        headerText: '表示優先度',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'status',
        headerText: '状態',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

export interface CollectionListSearchTableItem extends CollectionList {
  isSelected: boolean
}

@Component({
  components: { DataTable }
})
export default class CollectionListSearchTable extends ComponentVue {
  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): CollectionListSearchTableItem[] {
    if (this.sortColumn.name) {
      return orderBy<CollectionListSearchTableItem>(
        collectionListStore.searchResults,
        (item: CollectionListSearchTableItem) => {
          if (this.sortColumn.name === 'releaseDate') {
            return item.releaseStartDate + item.releaseEndDate
          }

          if (this.sortColumn.name === 'status') {
            return this.status(item)
          }

          // eslint-disable-next-line standard/computed-property-even-spacing
          return item[
            this.sortColumn.name as keyof CollectionListSearchTableItem
          ]
        },
        this.sortColumn.order as 'asc' | 'desc'[]
      )
    }

    return collectionListStore.searchResults
  }

  get sortColumn(): SortColumn {
    return collectionListStore.sortColumn
  }

  // storeのデータと常に同期する作りとする
  @Watch('sortColumn')
  onChangeSortColumn(): void {
    setSortOrder(this.cols, this.sortColumn)
  }

  status(item: CollectionListSearchTableItem): string {
    const currentDate: string = dayjs().format('YYYYMMDD')

    if (item.status === CollectionListStatus.Private) {
      return '非公開'
    } else if (item.status === CollectionListStatus.Public) {
      if (item.releaseStartDate > currentDate) {
        return '公開待'
      } else if (
        item.releaseStartDate <= currentDate &&
        (item.unlimitedFlag || item.releaseEndDate >= currentDate)
      ) {
        return '公開中'
      } else if (!item.unlimitedFlag && item.releaseEndDate < currentDate) {
        return '公開終了'
      }
    }

    return ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    collectionListStore.onSort({
      name: sortColItem?.name ?? '',
      order: sortColItem?.sortOrder ?? ''
    })
  }

  onClickRow(index: number): void {
    collectionListStore.selectSearchResults(
      collectionListStore.searchResults.findIndex(
        item => item.id === this.sortedItems[index].id
      )
    )
  }
}
